// Confetti: small rectangles falling with xmConfetti at staggered delays (QO10_Lit / QR1_Reward formula).
// Place inside a positioned, overflow-hidden screen. Decorative (aria-hidden). Reduced motion: falls instantly.
export interface ConfettiProps {
  count?: number;
  /** Colours cycled through (default cream, accent, green, blue, coral, accent). */
  colors?: string[];
  /** Extra delay before the first piece (ms). */
  delay?: number;
}

export function Confetti({ count = 16, colors, delay = 0 }: ConfettiProps) {
  const cs = colors || ['#F5F1EA', 'var(--acc)', '#7FC8A9', '#9DB7F5', '#F28B82', 'var(--acc)'];
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: 0, right: 0, top: 0, height: 0, overflow: 'visible', pointerEvents: 'none', zIndex: 30 }}>
      {Array.from({ length: count }, (_, i) => (
        <span key={i} style={{
          position: 'absolute', left: `${((12 + ((i * 53) % 360)) / 390) * 100}%`, top: -30, width: 6 + (i % 3) * 2, height: 10 + (i % 4) * 3,
          borderRadius: 2, background: cs[i % cs.length], opacity: 0,
          animation: `xmConfetti ${1700 + (i % 5) * 260}ms ${delay + 150 + (i % 7) * 120}ms ease-in both`,
        }} />
      ))}
    </div>
  );
}
